<template>
  <div class="resume-box">
    <!-- header -->
    <header class="resume-header">
      <h1 class="-title">履歴書フォーム</h1>
      <p>進捗 {{ progress }}</p>
    </header>
    <!-- フォーム -->
    <b-steps
      v-model="activeStep"
      size="is-small"
      :animated="true"
      :rounded="true"
      :has-navigation="true"
      label-position="bottom"
      mobile-mode="compact"
    >
      <!-- 基本 -->
      <b-step-item step="1" label="基本情報" :clickable="false">
        <div class="scroll-box">
          <h2>氏名（必須）</h2>
          <input class="input is-small" v-model="inputs.name" placeholder="履歴書 太郎" required />
          <h2>ふりがな（必須）</h2>
          <input
            class="input is-small"
            v-model="inputs.name_phonetic"
            placeholder="りれきしょ たろう"
          />
          <h2>性別（必須）</h2>
          <b-field>
            <input
              type="radio"
              name="sex"
              v-model="inputs.sex"
              value="1"
              class="radio-input"
              id="radio-01"
            />
            <label for="radio-01">男性</label>
            <input
              type="radio"
              name="sex"
              v-model="inputs.sex"
              value="2"
              class="radio-input"
              id="radio-02"
            />
            <label for="radio-02">女性</label>
          </b-field>
          <b-field>
            <input
              type="radio"
              name="sex"
              v-model="inputs.sex"
              value="3"
              class="radio-input"
              id="radio-03"
            />
            <label for="radio-03">選択しない</label>
          </b-field>
          <h2>生年月日（必須）</h2>
          <b-datepicker
            inline
            locale="ja-JP"
            size="is-small"
            v-model="inputs.birth"
            placeholder="生年月日を設定"
            :focused-date="defaultBirth"
            :max-date="new Date()"
            icon="calendar-today"
          >
          </b-datepicker>
          <h2>証明写真{{ image_required ? '（必須）' : '' }}</h2>
          <p style="text-align: left; font-size: 14px">
            ・撮影から3ヶ月以内のもの<br />
            ・単身胸から上の画像<br />
            ・縦：横＝4：3のもの
          </p>
          <button class="btn-flat-dashed-filled" @click="isFileUp = true">
            <b-icon icon="upload" size="is-large" style="margin-top: 10px"></b-icon><br />
            画像をアップロードする
          </button>
          <b-modal :active.sync="isFileUp" @close="isFileUp = false">
            <Cropper @imageMethod="imageMessage" />
          </b-modal>
          <div
            v-if="inputs.photo != ''"
            style="
              width: 150px;
              height: 200px;
              border: 1px solid gray;
              display: inline-block;
              vertical-align: top;
              margin-top: 10px;
            "
          >
            <img
              :src="inputs.photo"
              style="width: 150px; height: 200px; border: 1px solid gray"
              alt="Cropped Image"
            />
          </div>
          <h2>郵便番号（必須）</h2>
          <b-field>
            〒&nbsp;
            <input class="input is-small" v-model="inputs.postal_early" placeholder="123" />
            &nbsp;ー&nbsp;
            <input class="input is-small" v-model="inputs.postal_last" placeholder="4567" />
          </b-field>
          <h2>住所（必須）</h2>
          <p style="text-align: left; font-size: 12px;">※最大60文字まで</p>
          <b-field>
            <input
              class="input is-small"
              maxlength="60"
              v-model="inputs.address"
              placeholder="東京都港区西新橋X-X-X"
            />
          </b-field>
          <h2>電話番号（必須）</h2>
          <p style="text-align: left; font-size: 12px; color: red" v-if="!valid_tel">
            20文字以下にしてください。
          </p>
          <b-field>
            <input class="input is-small" v-model="inputs.tel" placeholder="0123-45-6789" />
          </b-field>
          <h2>メールアドレス（必須）</h2>
          <p style="text-align: left; font-size: 12px;">※半角で入力をお願いいたします。</p>
          <b-field>
            <input
              class="input is-small"
              v-model="inputs.email"
              @input="checkInput"
              placeholder="taro_rirekisyo@test.com"
            />
          </b-field>
        </div>
      </b-step-item>
      <b-step-item step="2" label="経歴・資格等" :clickable="false" @click="step = 2">
        <div class="scroll-box">
          <h2 id="link3">学歴</h2>
          <p style="text-align: left; font-size: 12px; color: red" v-if="!valid_gakureki">
            入力が不足しています。
          </p>
          <template v-for="(k, i) in gakurekiTable">
            <b-field :key="i + '-gakureki1'">
              <input class="input is-small" v-model="k.gakureki_nentsuki" type="month" />
              <button
                class="button is-small"
                style="margin-left: 4px"
                v-if="i != 0"
                @click="gakurekiTable.splice(i, 1)"
              >
                <span class="mdi mdi-close"></span>
              </button>
            </b-field>
            <b-field :key="i + '-gakureki2'">
              <input class="input is-small" v-model="k.gakureki" placeholder="〇〇高等学校　卒業" />
            </b-field>
          </template>
          <button
            class="button is-small"
            @click="gakurekiTable.push(JSON.parse(JSON.stringify(gakurekiData)))"
            v-if="gakurekiTable.length <= 10"
          >
            ＋ 追加
          </button>
          <h2 id="link4">職歴</h2>
          <p style="text-align: left; font-size: 12px; color: red" v-if="!valid_keireki">
            入力が不足しています。
          </p>
          <template v-for="(k, i) in keirekiTable">
            <b-field :key="i + '-keireki1'">
              <input class="input is-small" v-model="k.keireki_nentsuki" type="month" />
              <button
                class="button is-small"
                style="margin-left: 4px"
                v-if="i != 0"
                @click="keirekiTable.splice(i, 1)"
              >
                <span class="mdi mdi-close"></span>
              </button>
            </b-field>
            <b-field :key="i + '-keireki2'">
              <input class="input is-small" v-model="k.keireki" placeholder="株式会社XX　入社" />
            </b-field>
          </template>
          <button
            class="button is-small"
            @click="keirekiTable.push(JSON.parse(JSON.stringify(keirekiData)))"
            v-if="keirekiTable.length <= 10"
          >
            ＋ 追加
          </button>
          <h2 id="link4">免許・資格</h2>
          <p style="text-align: left; font-size: 12px; color: red" v-if="!valid_shikaku">
            入力が不足しています。
          </p>
          <template v-for="(s, i) in shikakuTable">
            <b-field :key="i + '-shikaku1'">
              <input class="input is-small" v-model="s.shikaku_nentsuki" type="month" />
              <button
                class="button is-small"
                style="margin-left: 4px"
                v-if="i != 0"
                @click="shikakuTable.splice(i, 1)"
              >
                <span class="mdi mdi-close"></span>
              </button>
            </b-field>
            <b-field :key="i + '-shikaku2'">
              <input class="input is-small" v-model="s.shikaku" placeholder="日商簿記2級" />
            </b-field>
          </template>
          <button
            class="button is-small"
            @click="shikakuTable.push(JSON.parse(JSON.stringify(shikakuData)))"
            v-if="shikakuTable.length <= 10"
          >
            ＋ 追加
          </button>
        </div>
      </b-step-item>
      <b-step-item step="3" label="その他" :clickable="false" @click="step = 3">
        <div class="scroll-box">
          <h2>志望の動機、自己PR、趣味、特技など（必須）</h2>
          <p style="text-align: left; font-size: 12px;">※最大200文字まで</p>
          <b-field>
            <textarea
              class="textarea is-small"
              maxlength="200"
              v-model="inputs.motive"
              placeholder="志望動機を入力してください"
            />
          </b-field>
          <h2>通勤時間</h2>
          <p style="text-align: left; font-size: 12px; color: red" v-if="!valid_commute_time">
            入力が正しくありません。
          </p>
          <b-field>
            <input
              class="input is-small"
              v-model="inputs.commute_hour"
              placeholder="0"
              type="number"
              min="0"
              style="width: 75px"
            />
            &nbsp;時間&nbsp;
            <input
              class="input is-small"
              v-model="inputs.commute_minute"
              placeholder="45"
              type="number"
              min="0"
              max="59"
              style="width: 75px"
            />
            &nbsp;分
          </b-field>
          <h2>扶養家族<br />（配偶者を除く）</h2>
          <p style="text-align: left; font-size: 12px; color: red" v-if="!valid_dependent">
            入力が正しくありません。
          </p>
          <b-field>
            <input
              class="input is-small"
              v-model="inputs.dependent"
              placeholder="1"
              min="0"
              type="number"
            />
            <b-field>&nbsp;人</b-field>
          </b-field>
          <h2>配偶者</h2>
          <b-field>
            <input
              type="radio"
              name="spouse"
              v-model="inputs.spouse"
              value="有"
              class="radio-input"
              id="radio-06"
            />
            <label for="radio-06">有</label>
            <input
              type="radio"
              name="spouse"
              v-model="inputs.spouse"
              value="無"
              class="radio-input"
              id="radio-07"
            />
            <label for="radio-07">無</label>
          </b-field>
          <h2>配偶者の扶養義務</h2>
          <b-field>
            <input
              type="radio"
              name="duty"
              v-model="inputs.duty"
              value="有"
              class="radio-input"
              id="radio-08"
            />
            <label for="radio-08">有</label>
            <input
              type="radio"
              name="duty"
              v-model="inputs.duty"
              value="無"
              class="radio-input"
              id="radio-09"
            />
            <label for="radio-09">無</label>
          </b-field>
          <h2>本人希望記入欄</h2>
          <b-field>
            <textarea
              class="textarea"
              maxlength="200"
              v-model="inputs.wish"
              placeholder="特に待遇・職種・勤務時間・その他についての希望などがあれば記入"
            />
          </b-field>
        </div>
      </b-step-item>
      <b-step-item step="4" label="確認" :clickable="false">
        <div class="scroll-box verification-screen" style="text-align: left">
          <p class="verification_text">以下の内容で情報を送信いたします。</p>
          <article>
            <div class="item-container">
              <div class="item-wrapper">
                <p class="item" style="padding: 5px">氏名</p>
                <p class="answer">{{ inputs.name }}</p>
              </div>
            </div>
            <div class="item-container">
              <div class="item-wrapper">
                <p class="item" style="padding: 5px">ふりがな</p>
                <p class="answer">{{ inputs.name_phonetic }}</p>
              </div>
            </div>
            <div class="item-container">
              <div class="item-wrapper">
                <p class="item" style="padding: 5px">性別</p>
                <p v-if="inputs.sex == 1" class="answer">男性</p>
                <p v-else-if="inputs.sex == 2" class="answer">女性</p>
                <p v-else-if="inputs.sex == 3" class="answer">選択しない</p>
              </div>
            </div>
            <div class="item-container">
              <div class="item-wrapper">
                <p class="item" style="padding: 5px">生年月日</p>
                <p class="answer">{{ displayBirthday(inputs.birth) }}</p>
              </div>
            </div>
            <div class="item-container">
              <div class="item-wrapper">
                <p class="item" style="padding: 5px; vertical-align: top">証明写真</p>
                <div
                  style="
                    width: 150px;
                    height: 200px;
                    border: 1px solid gray;
                    display: inline-block;
                    vertical-align: top;
                    margin-top: 10px;
                  "
                  v-if="inputs.photo"
                >
                  <img
                    class="answer"
                    :src="inputs.photo"
                    style="width: 150px; height: 200px; border: 1px solid gray"
                    alt="Cropped Image"
                  />
                </div>
                <div v-else>
                  <p class="answer">添付なし</p>
                </div>
              </div>
            </div>
            <div class="item-container">
              <div class="item-wrapper">
                <p class="item" style="padding-bottom: 5px">郵便番号</p>
                <p class="answer">{{ inputs.postal_early }}-{{ inputs.postal_last }}</p>
              </div>
            </div>
            <div class="item-container">
              <div class="item-wrapper">
                <p class="item" style="padding-bottom: 5px">住所</p>
                <p class="answer">{{ inputs.address }}</p>
              </div>
            </div>
            <div class="item-container">
              <div class="item-wrapper">
                <p class="item" style="padding-bottom: 5px">電話番号</p>
                <p class="answer">{{ inputs.tel }}</p>
              </div>
            </div>
            <div class="item-container">
              <div class="item-wrapper">
                <p class="item" style="padding-bottom: 5px">メールアドレス</p>
                <p class="answer">{{ inputs.email }}</p>
              </div>
            </div>
            <div class="item-container">
              <div class="item-wrapper">
                <p class="item" style="padding-bottom: 5px">経歴・学歴<br />（学歴）</p>
                <div class="answer">
                  <div v-for="(k, i) in gakurekiTable" :key="i + '-gakureki1'" class="box1">
                    <p>{{ k.gakureki_nentsuki }}</p>
                    <p>{{ k.gakureki }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="item-container">
              <div class="item-wrapper">
                <p class="item" style="padding-bottom: 5px"><br />（職歴）</p>
                <div class="answer">
                  <div v-for="(k, i) in keirekiTable" :key="i + '-keireki1'" class="box1">
                    <p>{{ k.keireki_nentsuki }}</p>
                    <p>{{ k.keireki }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="item-container">
              <div class="item-wrapper">
                <p class="item" style="padding-bottom: 5px">免許・資格</p>
                <div class="answer">
                  <div v-for="(s, i) in shikakuTable" :key="i + '-shikaku1'" class="box1">
                    <p>{{ s.shikaku_nentsuki }}</p>
                    <p>{{ s.shikaku }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="item-container">
              <div class="item-wrapper">
                <p class="item" style="padding-bottom: 5px">志望の動機、自己PR、趣味、特技など</p>
                <p class="answer">{{ inputs.motive }}</p>
              </div>
            </div>
            <div class="item-container">
              <div class="item-wrapper">
                <p class="item" style="padding-bottom: 5px">通勤時間</p>
                <p class="answer">{{ inputs.commute_hour }}時間{{ inputs.commute_minute }}分</p>
              </div>
            </div>
            <div class="item-container">
              <div class="item-wrapper">
                <p class="item" style="padding-bottom: 5px">扶養家族（配偶者を除く）</p>
                <p class="answer">{{ inputs.dependent }}人</p>
              </div>
            </div>
            <div class="item-container">
              <div class="item-wrapper">
                <p class="item" style="padding-bottom: 5px">配偶者</p>
                <p class="answer">{{ inputs.spouse }}</p>
              </div>
            </div>
            <div class="item-container">
              <div class="item-wrapper">
                <p class="item" style="padding-bottom: 5px">配偶者の扶養義務</p>
                <p class="answer">{{ inputs.duty }}</p>
              </div>
            </div>
            <div class="item-container">
              <div class="item-wrapper">
                <p class="item" style="padding-bottom: 5px">本人希望記入欄</p>
                <p class="answer">{{ inputs.wish }}</p>
              </div>
            </div>
          </article>
        </div>
      </b-step-item>
      <template slot="navigation" slot-scope="{ previous, next }">
        <div style="width: 100%; display: flex">
          <template v-if="step < 4">
            <button
              class="button is-small is-fullwidth"
              :disabled="previous.disabled"
              @click.prevent="previous.action"
              @click="move('back')"
            >
              <span class="mdi mdi-chevron-left"></span> 前へ
            </button>
          </template>
          <template v-if="!next.disabled && step < 3">
            <button
              class="button is-small is-fullwidth"
              :disabled="next.disabled"
              @click.prevent="next.action"
              @click="move('adv')"
            >
              次へ <span class="mdi mdi-chevron-right"></span>
            </button>
          </template>
          <template v-else-if="!next.disabled && step === 3">
            <button
              class="button is-small is-fullwidth"
              :disabled="disabled"
              @click.prevent="next.action"
              @click="move('adv')"
            >
              確認画面へ <span class="mdi mdi-chevron-right"></span>
            </button>
          </template>
          <template v-else-if="step === 4" class="button-container">
            <button
              class="button is-small is-fullwidth"
              :disabled="previous.disabled"
              @click.prevent="previous.action"
              @click="move('back')"
            >
              <span class="mdi mdi-chevron-left" style="margin-right: 4px"></span> 再入力する
            </button>
            <button
              class="button is-primary is-small is-fullwidth"
              @click.once="clickCreateResume()"
              :disabled="isNowButton() || isPast || disabled"
            >
              <span v-if="!resumeLoading" class="mdi mdi-send" style="margin-right: 4px"
                >送信する</span
              >
              <span class="mdi mdi-loading mdi-spin" v-if="resumeLoading"></span>
            </button>
          </template>
        </div>
        <p class="message" v-if="isPdfCreating">
          現在履歴書を読み込んでおります。今しばらくお待ちください。
          <span class="mdi mdi-loading mdi-spin" style="font-size: 14px;"></span>
        </p>
      </template>
    </b-steps>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Cropper from '@/views/DashBoard/ChatBot/Cropperjs'
import { isNowButton, messageEscape } from '@/functions/balloonFunc'
export default {
  name: 'Resume',
  components: {
    Cropper,
  },
  props: ['parameter', 'isDemo', 'logIndex', 'lastIndex', 'speaker', 'isPast', 'roboArguments'],
  data() {
    return {
      step: 1,
      activeStep: 0,
      formTable: [
        'プロフィール',
        '　　住所　　',
        '　　経歴　　',
        '免許・資格　',
        '　志望動機　',
        '通勤時間ほか',
        '本人希望欄　',
      ],
      shikakuTable: [
        {
          shikaku_nentsuki: null,
          shikaku: null,
        },
      ],
      keirekiTable: [
        {
          keireki_nentsuki: null,
          keireki: null,
        },
      ],
      gakurekiTable: [
        {
          gakureki_nentsuki: null,
          gakureki: null,
        },
      ],
      shikakuData: {
        shikaku_nentsuki: null,
        shikaku: null,
      },
      keirekiData: {
        keireki_nentsuki: null,
        keireki: null,
      },
      gakurekiData: {
        gakureki_nentsuki: null,
        gakureki: null,
      },
      isFileUp: false,
      inputs: require('@/assets/json/resume/inputs.json'),
      sendedFlg: false,
      isPdfCreating: false,
      defaultBirth: null
    }
  },
  computed: {
    image_required() {
      if (this.parameter) {
        if (typeof this.parameter.image_required != 'boolean') {
          return true
        } else {
          return this.parameter.image_required
        }
      } else {
        return true
      }
    },
    progress() {
      const max = this.image_required ? 11 : 10
      let count = 0
      if (this.inputs.name) count++
      if (this.inputs.name_phonetic) count++
      if (this.inputs.sex) count++
      if (this.inputs.birth) count++
      if (this.inputs.photo && this.image_required) count++
      if (this.inputs.email) count++
      if (this.inputs.tel && this.valid_tel) count++
      if (this.inputs.postal_early) count++
      if (this.inputs.postal_last) count++
      if (this.inputs.address) count++
      if (this.inputs.motive) count++
      return Math.round((count / max) * 100) + '%'
    },
    disabled() {
      if (!this.inputs.name) return true
      if (!this.inputs.name_phonetic) return true
      if (!this.inputs.sex) return true
      if (!this.inputs.birth) return true
      if (!this.inputs.photo && this.image_required) return true
      if (!this.inputs.email) return true
      if (!this.inputs.tel || !this.valid_tel) return true
      if (!this.inputs.postal_early) return true
      if (!this.inputs.postal_last) return true
      if (!this.inputs.address) return true
      if (!this.valid_keireki) return true
      if (!this.valid_shikaku) return true
      if (!this.inputs.motive) return true
      if (!this.valid_commute_time) return true
      if (!this.valid_dependent) return true
      return false
    },
    ...mapState('directtalk', [
      'color',
      'resume',
      'pdfFile',
      'seeker',
      'data',
      'targetID',
      'resumeLoading',
      'pdfCreating'
    ]),
    valid_tel() {
      if (this.inputs.tel && this.inputs.tel.length > 20) return false
      return true
    },
    valid_commute_time() {
      if (this.inputs.commute_hour == '') return false
      if (isNaN(Number(this.inputs.commute_hour)) || Number(this.inputs.commute_hour) < 0)
        return false
      if (this.inputs.commute_minute == '') return false
      if (isNaN(Number(this.inputs.commute_minute)) || Number(this.inputs.commute_minute) < 0)
        return false
      return true
    },
    valid_dependent() {
      if (this.inputs.dependent == '') return false
      if (isNaN(Number(this.inputs.dependent)) || Number(this.inputs.dependent) < 0) return false
      return true
    },
    valid_keireki() {
      if (
        this.keirekiTable.length == 1 &&
        !this.keirekiTable[0].keireki_nentsuki &&
        !this.keirekiTable[0].keireki
      )
        return true
      if (!this.keirekiTable.every((item) => item.keireki_nentsuki && item.keireki)) return false
      return true
    },
    valid_gakureki() {
      if (
        this.gakurekiTable.length == 1 &&
        !this.gakurekiTable[0].gakureki_nentsuki &&
        !this.gakurekiTable[0].gakureki
      )
        return true
      if (!this.gakurekiTable.every((item) => item.gakureki_nentsuki && item.gakureki)) return false
      return true
    },
    valid_shikaku() {
      if (
        this.shikakuTable.length == 1 &&
        !this.shikakuTable[0].shikaku_nentsuki &&
        !this.shikakuTable[0].shikaku
      )
        return true
      if (!this.shikakuTable.every((item) => item.shikaku_nentsuki && item.shikaku)) return false
      return true
    },
  },
  mounted () {
    if (!this.parameter['default_birth']) {
      this.defaultBirth = new Date()
    } else {
      this.defaultBirth = new Date(this.parameter['default_birth'])
    }
  },
  watch : {
    pdfCreating () {
      this.isPdfCreating = this.pdfCreating
    }
  },
  methods: {
    // メールアドレス用の入力内容制限メソッド
    checkInput() {
      // 正規表現でASCII文字以外を削除
      // 削除対象：全角の英大文字、英小文字、数字、記号、カタカナ、漢字、特殊記号、絵文字 等
      this.inputs.email = this.inputs.email.replace(/[^\x00-\x7F]/g, "")
    },
    messageEscape (m) {
      return messageEscape(m, this.roboArguments)
    },
    isNowButton() {
      return isNowButton(this.logIndex, this.lastIndex, this.speaker)
    },
    displayBirthday(birthday) {
      if (birthday === null) {
        return ''
      } else {
        var birthday = new Date(birthday)
        return birthday.getFullYear() + '/' + (birthday.getMonth() + 1) + '/' + birthday.getDate()
      }
    },
    move(word) {
      if (word == 'adv') {
        this.step += 1
      } else {
        this.step -= 1
      }
    },
    clickCreateResume() {
      if (this.isDemo) {
        const skdata = {
          name: this.inputs.name ? this.inputs.name : '',
          name_phonetic: this.inputs.name_phonetic ? this.inputs.name_phonetic : '',
          sex: this.inputs.sex ? this.inputs.sex : '',
          birth: this.inputs.birth ? this.inputs.birth.toISOString() : '',
          email: this.inputs.email ? this.inputs.email : '',
          tel: this.inputs.tel ? this.inputs.tel : '',
          address: this.inputs.address ? this.inputs.address : '',
        }
        this.$emit('send-resume', skdata)
        this.sendedFlg = true
      } else {
        const skdata = {
          id: this.seeker.pk,
          name: this.inputs.name,
          name_phonetic: this.inputs.name_phonetic,
          sex: this.inputs.sex,
          birth: this.inputs.birth.toISOString(),
          email: this.inputs.email,
          tel: this.inputs.tel,
          postalcode: this.inputs.postal_early + '-' + this.inputs.postal_last,
          address: this.inputs.address,
          message: this.inputs.motive,
          requirement: this.inputs.wish,
          other:
            '▼通勤時間\n' +
            (this.inputs.commute_hour == 0 && this.inputs.commute_minute == 0
              ? '-時間-分'
              : this.inputs.commute_hour + '時間' + this.inputs.commute_minute + '分') +
            '\n▼扶養家族\n' +
            this.inputs.dependent +
            '人\n▼配偶者\n' +
            this.inputs.spouse +
            '\n▼配偶者の扶養義務\n' +
            this.inputs.duty,
          is_subscribe: true,
          is_resume: true,
          subscribe_count: 1,
          subscribe_date: new Date().toISOString(),
          progress_rate: 0,
        }

        // 訪問者データ更新
        this.$store.dispatch('directtalk/updateSeekerAny', skdata)
        this.$store.dispatch('directtalk/createSeekerATHistory', {
          target: this.targetID,
          action: 'subscribe_bot',
          url: this.data.url,
          element: 'button',
        })
        let createFiles = new FormData()

        // base64からblobを生成
        const bin = atob(this.inputs.photo.replace(/^.*,/, ''))
        const buffer = new Uint8Array(bin.length).map((_, i) => bin.charCodeAt(i))
        const blob = new Blob([buffer.buffer], {
          type: 'image/png',
        })

        // 証明写真の登録
        let image_name = ''
        if (this.inputs.photo) {
          image_name = this.inputs.name
            ? this.inputs.name.replace(/\..*$/, '') + '.png'
            : 'image.png'
          createFiles.append('file', blob, image_name)
          createFiles.append('name', image_name)
          createFiles.append('seeker', this.seeker.pk)
          this.$store.dispatch('directtalk/createSeekerFilesAny', createFiles)
        }

        this.$store.dispatch('directtalk/deleteResume', this.seeker.pk)
          .then((d) => {
            // 学歴の登録
            for (let k of this.gakurekiTable) {
              if (!k.gakureki_nentsuki || !k.gakureki) continue
              let gakureki_nen = k.gakureki_nentsuki.substring(0, k.gakureki_nentsuki.indexOf('-'))
              let gakureki_tsuki = k.gakureki_nentsuki.slice(k.gakureki_nentsuki.indexOf('-') + 1)
              let createCareer = {
                career_year: Number(gakureki_nen),
                career_month: Number(gakureki_tsuki),
                career_body: k.gakureki,
                seeker: this.seeker.pk,
              }
              this.$store.dispatch('directtalk/createCareerAny', createCareer)
            }

            // 職歴の登録
            for (let k of this.keirekiTable) {
              if (!k.keireki_nentsuki || !k.keireki) continue
              let keireki_nen = k.keireki_nentsuki.substring(0, k.keireki_nentsuki.indexOf('-'))
              let keireki_tsuki = k.keireki_nentsuki.slice(k.keireki_nentsuki.indexOf('-') + 1)
              let createCareer = {
                career_year: Number(keireki_nen),
                career_month: Number(keireki_tsuki),
                career_body: k.keireki,
                seeker: this.seeker.pk,
              }
              this.$store.dispatch('directtalk/createCareerAny', createCareer)
            }

            // 資格の登録
            for (let s of this.shikakuTable) {
              if (!s.shikaku_nentsuki || !s.shikaku) continue
              let shikaku_nen = s.shikaku_nentsuki.substring(0, s.shikaku_nentsuki.indexOf('-'))
              let shikaku_tsuki = s.shikaku_nentsuki.slice(s.shikaku_nentsuki.indexOf('-') + 1)
              let createQualification = {
                qualification_year: Number(shikaku_nen),
                qualification_month: Number(shikaku_tsuki),
                qualification_body: s.shikaku,
                seeker: this.seeker.pk,
              }
              this.$store.dispatch('directtalk/createQualificationAny', createQualification)
            }
            this.sendedFlg = true

            let resumeData = null
            if (this.parameter.is_make_pdf) {
              if (
                this.parameter.enable_download === true ||
                this.parameter.applicant_manage === true ||
                this.parameter.send_mail === true ||
                this.parameter.save_google_drive === true
              ) {
                this.$store.dispatch('directtalk/setPdfCreating', true)
                // 入力値をPDF出力
                resumeData = {
                  parameter: this.parameter,
                  seeker_pk: this.seeker.pk,
                  base: this.inputs,
                  photo_name: image_name,
                }
              }
            }
            // 次のシナリオへ
            this.$emit('send-resume', skdata, resumeData)
          })
          .catch(() => {
            alert('エラーが発生いたしました。')
          })
      }
    },
    imageMessage(photo) {
      this.inputs.photo = photo
    },
  },
}
</script>

<style lang="scss" scoped>
.resume-box {
  padding: 16px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  height: 650px;
  border-radius: 8px;
  .resume-header {
    padding: 4px;
    margin-bottom: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    h1 {
      font-size: 16px;
      font-weight: 600;
      text-align: left;
    }
  }
  /deep/ .step-title {
    font-size: 10px !important;
  }
  /deep/ .step-content {
    padding: 8px 0 !important;
  }
}
.scroll-box {
  table-layout: fixed;
  width: 100%;
  padding: 4px;
  overflow-y: scroll;
  height: 400px;
  background-color: white;
}
.scroll-box::-webkit-scrollbar {
  width: 8px;
}
.scroll-box::-webkit-scrollbar-thumb {
  background: #c1c1c1;
}
.scroll-box::-webkit-scrollbar-track-piece:start {
  background: #f1f1f1;
}
.scroll-box::-webkit-scrollbar-track-piece:end {
  background: #f1f1f1;
}
h2 {
  position: relative;
  padding-left: 30px;
  padding-top: 10px;
  font-size: 14px;
  color: #325a8c;
  text-align: left;
  margin-bottom: 8px;
}
h2::before,
h2::after {
  content: '□';
  position: absolute;
  padding-top: 10px;
}
h2::before {
  left: 0;
  top: -3px;
}
h2::after {
  left: 5px;
  top: 3px;
  color: #a1b8d1;
}
.radio-input {
  display: none;
}
.radio-input + label {
  padding-left: 20px;
  padding-top: 5px;
  position: relative;
  margin-right: 20px;
  font-size: 14px;
}
.radio-input + label::before {
  content: '';
  display: block;
  position: absolute;
  top: 10px;
  left: 0;
  width: 15px;
  height: 15px;
  border: 1px solid #999;
  border-radius: 50%;
}
.radio-input:checked + label {
  color: #009a9a;
}
.radio-input:checked + label::after {
  content: '';
  display: block;
  position: absolute;
  top: 12px;
  left: 2px;
  width: 11px;
  height: 11px;
  background: #009a9a;
  border-radius: 50%;
}
.btn-flat-dashed-filled {
  display: block;
  padding: 0.5em 1em;
  text-decoration: none;
  color: gray;
  border: dashed 1px #ccc;
  background: #ffffff;
  border-radius: 3px;
  transition: 0.4s;
  height: 100px;
  width: 190px;
  margin-top: 8px;
  margin-right: 10px;
}
.btn-flat-dashed-filled:hover {
  background: #ffa9fb;
  color: #000000;
}
.verification-screen {
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  padding: 16px;
  article {
    font-size: 13px;
    word-wrap: break-word;
  }
}
.item-container {
  margin-top: 16px;
}
.item-wrapper {
  display: flex;
  .item {
    width: 100px;
    padding-left: 8px;
    margin-right: 16px;
  }
  .answer {
    width: 65%;
    font-weight: bold;
  }
}
.horizontal-list {
  overflow-x: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  padding: 0;
}
.horizontal-list ul {
  /* 横スクロール用 */
  display: inline-block;
}
.verification_text {
  height: 38px;
  font-size: 14px;
  padding: 8px;
  background: rgba(200, 200, 200, 0.4);
}
.button-container {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
}
.box1 {
  width: 160px;
  padding: 0.5em 1em;
  margin-bottom: 16px;
  font-weight: bold;
  border: solid 1px #d3d3d3;
}
.box1 p {
  margin: 0;
  padding: 0;
}
.message {
  text-align: left;
  padding: 16px;
  width: auto;
  max-width: -webkit-fill-available;
  word-wrap: break-word;
  border-radius: 8px;
  font-size: smaller;
  white-space: pre-line;
  transition: 0.7s;
}
</style>



// WEBPACK FOOTER //
// src/components/BalloonParts/ResumeParts.vue